import { DashboardModule } from '@domain-group/suit-theme'

import type { EntitiesState } from '@redux/entities'
import type { TaskListItemModel } from '@domain-group/realhub-backend-api-types'

import useUser from '@hooks/useUser'

import TasksTable from './TasksTable'

interface TaskGroupProps {
  assigneeId: number,
  entities: EntitiesState,
  taskListItems: TaskListItemModel[],
}

const TaskGroup = (props: TaskGroupProps) => {
  const { assigneeId, entities, taskListItems } = props

  const userPayload = useUser({ id: assigneeId })
  const { user: { full_name } } = userPayload

  return (
    <DashboardModule title={full_name || 'Unknown User'}>
      <TasksTable
        entities={entities}
        taskListItems={taskListItems}
      />
    </DashboardModule>
  )
}

export default TaskGroup
